// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2c094","checkboxCol":"Table_checkboxCol__2Q8N5","emailCol":"Table_emailCol__1NZ2-","actionCol":"Table_actionCol__1R7J6"};